import { render, staticRenderFns } from "./TrademarkOppositionForm.vue?vue&type=template&id=09a4ceb6&"
import script from "./TrademarkOppositionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionForm.vue?vue&type=style&index=0&id=09a4ceb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports